export default {

  namespaced: true,

  state: {
    content: {
      main: [
        'Restou alguma duvida?',
        'Mande sua mensagem para trocarmos uma ideia ;)'
      ]
    }
  },

  getters: {
  },

  mutations: {
  },

  actions: {
  }
}